export const Affiliations = {
  en: [
    {
      title: 'Research / Academia',
      value: 1
    },
    {
      title: 'Marketing & Sales',
      value: 2
    },
    {
      title: 'Content Creation',
      value: 3
    },
    {
      title: 'Business Operations',
      value: 4
    },
    {
      title: 'Personal Use',
      value: 5
    }
  ],
  es: [
    {
      title: 'Investigación / Academia',
      value: 1
    },
    {
      title: 'Marketing y ventas',
      value: 2
    },
    {
      title: 'Creación de contenidos',
      value: 3
    },
    {
      title: 'Operaciones comerciales',
      value: 4
    },
    {
      title: 'Uso personal',
      value: 5
    }
  ]
};
